import { render } from "./commonStatisticsBarChart.vue?vue&type=template&id=c12fc9c2&scoped=true"
import script from "./commonStatisticsBarChart.vue?vue&type=script&lang=js"
export * from "./commonStatisticsBarChart.vue?vue&type=script&lang=js"

import "./commonStatisticsBarChart.vue?vue&type=style&index=0&id=c12fc9c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12fc9c2"]])

export default __exports__